import React, { useEffect } from 'react';
import { DealPipelineView } from '@/components/views/DealPipelineView';
import { AuthenticatedPageLayout } from '@/components/layouts/AuthenticatedPageLayout';

export const RenewalsPage = () => {

	return (<AuthenticatedPageLayout>
		<DealPipelineView pipelineId={process.env.REACT_APP_PIPELINE_RENEWALS}/>
	</AuthenticatedPageLayout>);
};